module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-8 contact_form add-prd-item"
  }, [_c('h6', [_vm._v("Add New Item ")]), _vm._v(" "), _c('form', {
    staticClass: "sp-forms-one"
  }, [_c('ul', {
    staticClass: "row"
  }, [_c('li', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v(" *Product Price\n                        "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_item_price),
      expression: "product.product_item_price"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "value": "",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.product.product_item_price)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_item_price = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v(" *Product Weight\n                        "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_item_weight),
      expression: "product.product_item_weight"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "step": "any",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.product.product_item_weight)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_item_weight = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v(" *Product Quantity\n                        "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_item_quantity),
      expression: "product.product_item_quantity"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.product.product_item_quantity)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_item_quantity = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v(" Product Image")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "input-file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.onFileChange($event)
      }
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "col-md-6"
  }, [_c('button', {
    staticClass: "btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addProductItem
    }
  }, [_vm._v("Add")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1e0850b6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/product/ProductItemForm.vue
// module id = 254
// module chunks = 0